import { useState } from "react"
import axiosInstance from "../../../../services/axios-client"
import { toast } from "react-toastify"

const useJustificationModelLatest = () => {
    const [latestJustification, setLatestJustification] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const getJustification = async(ProjectID, EmployeeID, CalibratorID) => {
        try {
            setIsLoading(true)
            let res = await axiosInstance.get(`/auth/calibrations/get-latest-justification?projectID=${ProjectID}&calibratorID=${CalibratorID}&employeeID=${EmployeeID}`)
            if (res.status === 200) {
                // console.log("isi justification", res.data.data)
                setLatestJustification(res.data.data)
            }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        } finally {
            setIsLoading(false)
        }
    }

    return{
        getJustification,
        latestJustification,
        isLoading,
    }
}

export default useJustificationModelLatest